import React from 'react';
import { Warranty } from './Italics.style';

interface ItalicProps {
  label: string;
  lang: string;
}

const Italics: React.FC<ItalicProps> = ({ label, lang }) => {
  const stringCert = label.toString().split(' ');
  const pop = stringCert.pop();
  let certified = stringCert.filter((item) => item !== pop).join(' ');
  const plus = label.slice(-5);

  if (lang === 'fr') {
    stringCert.shift();
    const Audi = stringCert.shift();
    certified = stringCert.filter((item) => item !== pop).join(' ');

    return (
      <Warranty>
        {Audi}&nbsp;
        <span className="regular">{certified}&nbsp;</span>
        <span className="italics">{plus}</span>
      </Warranty>
    );
  }

  return (
    <Warranty>
      Audi&nbsp;
      <span className="regular">{certified}&nbsp;</span>
      <span className="italics">{plus}</span>
    </Warranty>
  );
};

export default Italics;
